var addToCartBtn=document.querySelector('.cart__checkout');
var productBtn=document.querySelector('.add-to-cart');
document.addEventListener('drawerOpen', async function(evt) {
document.querySelector('.card-load ').classList.add('is-loading');
   /*  var url = ''.concat(theme.routes.cart, '?t=').concat(Date.now());
    var response = await fetch(url, {
        credentials: 'same-origin',
        method: 'GET'
      }).then( response => {
    return  response.json();
}) 

//alert("drawerOpen");
//gwpOffers(response);

*/ await upsellSection();
document.querySelector('.card-load ').classList.remove('is-loading');

});

document.addEventListener('cart:updated', async function(evt) {
  document.querySelector('.card-load ').classList.add('is-loading');
 // console.log("cart:updated",evt.detail.cart);
  if(evt.detail.property=="_offerXProduct")
  {
     await processbuyXgetYOffers(evt.detail.cart)  
  }
  else { //alert("cart:updated");
    await gwpOffers(evt.detail.cart,false);  
    await freeShippingBar(evt.detail.cart,false);
  }
 await upsellSection();
});


document.addEventListener('ajaxProduct:added', async function(evt) {
document.querySelector('.card-load').classList.add('is-loading');
  //console.log("ajaxProduct",evt.detail.product);
   var url = ''.concat(theme.routes.cart, '?t=').concat(Date.now());
    var response = await fetch(url, {
        credentials: 'same-origin',
        method: 'GET'
      }).then( response => {
    return  response.json();
})
  if(evt.detail.product.properties && evt.detail.product.properties._offerXProduct ){ 
  processbuyXgetYOffers(response,false)  
  }
  else { //alert("ajaxProduct:added");
    gwpOffers(response,false)
    freeShippingBar(response,false)
  }
//document.querySelector('.card-load ').classList.remove('is-loading');
});

function freeShippingBar(cart, openCart) {
    const offers = JSON.parse(document.getElementById("CartGwpOffer").textContent).offers;
    var cartData = cart;
    var cartTotal = cartData.total_price / 100; // Divide by 100 to convert cents to rupees
    var subtractSubstrings = ['_Offer', '_offerXProduct'];

    // Loop through cartData.items and subtract prices of items with specific properties
    cartData.items.forEach(item => {
        if (item.product_type == 'Combos' || item.product_type == 'Kit') {
            cartTotal -= item.line_price / 100; // Divide by 100 to convert cents to rupees
        }
        if (item.properties) {
            for (var prop in item.properties) {
                if (subtractSubstrings.some(substring => prop.includes(substring))) {
                    cartTotal -= item.line_price / 100; // Divide by 100 to convert cents to rupees
                    break;
                }
            }
        }
    });

    //console.log(cartData, "ProgressUpdated cartTotal:", cartTotal);

    const progressBar = document.getElementById('shipping-bar-progress');
    const milestonesContainer = document.getElementById('shipping-bar-milestones');
    const messageContainer = document.getElementById('shipping-bar-message');

    // Clear previous content
    milestonesContainer.innerHTML = '';

    let message = '';
    let progressPercentage = 0;
    let messageSet = false; // Flag to track if the message has been set

    offers.forEach((offer, index) => {
        const milestone = document.createElement('div');
      if(offers.length - 1 > index) {
        var incrementIndex= parseInt(index + 1);
      }
      else { var incrementIndex= index; }
        milestone.className = `shipping-bar__milestone${cartTotal > offer.cart_total_above ? ' active' : ''}`;

        const milestoneIndicator = document.createElement('div');
        milestoneIndicator.className = 'shipping-bar__milestone-indicator';
        milestoneIndicator.style.left = `${(offer.cart_total_above / offers[incrementIndex].cart_total_above) * 100}%`;
        milestone.appendChild(milestoneIndicator);

        const milestoneText = document.createElement('div');
        milestoneText.className = 'shipping-bar__milestone-text';
        milestoneText.textContent = `₹${offer.cart_total_above}`;
      //console.log(incrementIndex,offer.cart_total_above,"offers[offers.length - 1].cart_total_above:",offers[offers.length - 1].cart_total_above)
       // milestoneText.style.left = `${(offer.cart_total_above / offers[offers.length - 1].cart_total_above) * 100}%`;
      milestoneText.style.left = `${(offer.cart_total_above / offers[incrementIndex].cart_total_above) * 100}%`;
        milestone.appendChild(milestoneText);

        milestonesContainer.appendChild(milestone);

        if (cartTotal >= offer.cart_total_above) {
            if (index === offers.length - 1) {
                // If this is the last offer, show the post message
                message = offer.message_if_cart_value_is_greater_than_offer_value;
            } else {
                // Otherwise, continue to the next offer
                messageSet = false;
            }
        } else if (!messageSet) {
            // If the cart total is less than the current offer and message is not yet set
            var remainingAmount = Math.round(offer.cart_total_above - cartTotal);
          if(remainingAmount == 0) {remainingAmount = 1 }
            message = offer.message_if_cart_value_is_less_than_offer_value.replace("[value]", remainingAmount).replace('[title]', document.querySelector('#offerPriceContent_' + offer.offerProperty).dataset.productTitle);
            messageSet = true;
        }

        if (cartTotal >= offer.cart_total_above) {
            progressPercentage = ((index + 1) / offers.length) * 100;
        } else if (!progressPercentage) {
          //console.log("cartTotal:",cartTotal,"offer.cart_total_above:",offer.cart_total_above,"((index + 1) / offers.length):",((index + 1) / offers.length))
            progressPercentage = (cartTotal / offers[offers.length - 1].cart_total_above) * ((index + 1) / offers.length) * 100;
           //console.log("progressPercentage:",progressPercentage);
        }
    });

    // Ensure progressPercentage does not exceed 100%
    progressPercentage = Math.min(progressPercentage, 100);

    progressBar.style.width = `${progressPercentage}%`;
    messageContainer.textContent = message;
}

// Fetch the section using the Shopify Section Rendering API
  async function upsellSection() {
  const sectionUrl = window.Shopify.routes.root + 'cart?view=upsell-items';
  const response = await fetch(sectionUrl);
  const sectionData = await response.text();
  const html = document.createElement('div');
   html.innerHTML = sectionData;
   document.querySelector(".upsell__products_container").innerHTML=html.innerHTML;
   var CartDrawer =document.querySelector('#CartDrawer');
  eval(document.querySelector("#upsellFlickity").innerHTML)
   CartDrawer.querySelectorAll('.upsell-button').forEach(function(upsell){
   upsell.addEventListener('click', async function(evt) {
    addToCartBtn.classList.add('btn--loading');
        let formData = {
        'items': [{
        'id': evt.target.dataset.id,
        'quantity': 1
      }]
        };
      var result = await addProducts(formData);
      var url = ''.concat(theme.routes.cart, '?t=').concat(Date.now());
      var response = await fetch(url, {
        credentials: 'same-origin',
        method: 'GET'
      }).then( response => {
    return  response.json();
    })
     await gwpOffers(response);
     await upsellSection();
     await freeShippingBar(response,false)
     document.dispatchEvent(new CustomEvent('cart:build'));
     addToCartBtn.classList.remove('btn--loading');
})
})
}



async function gwpOffers(cart,openCart){ 
  addToCartBtn.classList.add('btn--loading');
  var cartData= cart;
  var cartTotal = cartData.total_price;
  var scriptElement=document.querySelector("#CartGwpOffer");
  var gwpOffers = scriptElement.textContent;
  gwpOffers = JSON.parse(gwpOffers);
// Define the substrings and properties to consider for subtracting from cartTotal
//var subtractSubstrings = ['buyX', '_offerXProduct'];
var subtractSubstrings = ['_Offer', '_offerXProduct'];
// Loop through cartData.items and subtract prices of items with specific properties
cartData.items.forEach(item => {
  if(item.product_type == 'Combos' || item.product_type == 'Kit'){
  cartTotal -= item.line_price;  
  }
  if (item.properties) {
    for (var prop in item.properties) {
      if (subtractSubstrings.some(substring => prop.includes(substring))) {
        cartTotal -= item.line_price;
        break;
      }
    }
  }
});
console.log(cartData,"Updated cartTotal:", cartTotal);
//In this code, we use the subtractSubstrings array to define the substrings and properties to consider for subtracting from cartTotal. The code then iterates through each item in cartData.items, and for each property in item.properties, it checks if the property key contains any of the specified substrings using the some method. If a match is found, it subtracts the item's price from cartTotal.

  cartTotal = cartTotal/100;
// Iterate through each offer in gwpOffers.offers
  document.querySelectorAll('.offerPriceContentSection').forEach(div => div.style.display = 'none');
  var gwpMessageDisplayPre=false
  var gwpMessageDisplayPost=false
   // Arrays to store formData objects for add and remove operations

  const addFormDataArray=[];
  let finalFormData = {};
  const keyIds = [];
  const promises = gwpOffers.offers.map(async offer => {
  // Check if cartTotal is less than cart_total_above
  console.log(cartTotal, "<", offer.cart_total_above)
  if (cartTotal < offer.cart_total_above) {
    // offer message display on the bottom
    if(!gwpMessageDisplayPre){
    var diff= Math.round(offer.cart_total_above-cartTotal);
  //if(diff ==0) { diff = 1;}
    var offerMessage= (offer.message_if_cart_value_is_less_than_offer_value).replace('[value]',diff);
    offerMessage= `<div class="offer-content"><span>`+(offerMessage).replace('[title]',document.querySelector('#offerPriceContent_'+offer.offerProperty).dataset.productTitle)+`</span>`;
    var image=  `<div class="offer-img"><img src="${document.querySelector('#offerPriceContent_'+offer.offerProperty).dataset.productImg}" /></div>`;
    var bottom_message=`<div><span>${document.querySelector('#offerPriceContent_'+offer.offerProperty).dataset.productTitle}</span></div><div><span class="cart__price cart__price--strikethrough">${document.querySelector('#offerPriceContent_'+offer.offerProperty).dataset.productPrice}</span><span class="ajaxcart__price">FREE</span></div></div>`;
    document.querySelector('#offerPriceContent_'+offer.offerProperty).innerHTML=image+offerMessage+bottom_message;
    document.querySelector('#offerPriceContent_'+offer.offerProperty).style.display="";
    gwpMessageDisplayPre=true;
    }
    // Check if the offerProperty value is found in CartData.items
    let offerPropertyFound = cartData.items.find(item => item.properties && item.properties._Offer==offer.offerProperty);
    //console.log("offerPropertyFound",offerPropertyFound)
    if (offerPropertyFound) {
      var keyId=  offerPropertyFound.key;
      keyIds.push(keyId);
      
       //var result= await removeProducts(formData); 
      //console.log(`Product '${offer.offerProperty}' removed from the cart.`);
    }
  }
  else {
  
    // Check if the offerProperty value is found in CartData.items
    let offerPropertyFound = cartData.items.some(item => item.properties && item.properties._Offer==offer.offerProperty);
    if (!offerPropertyFound) {
      //   let formData = {
      //   'id': offer.free_product_main,
      //   'quantity': 1,
      //   "properties" : {
      //   "_Offer": `${offer.offerProperty}`,
      //   "_Offer-limit":`${offer.cart_total_above}`
      // }
      //   };
        
    
   // addFormDataArray.push(formData);
    //console.log(`Product '${offer.offerProperty}' added to the cart.`);
    //console.log("offerPropertyFound",offerPropertyFound)
     if(!gwpMessageDisplayPost){
    document.querySelector('#offerPriceContent_'+offer.offerProperty).innerHTML=offer.message_if_cart_value_is_greater_than_offer_value;
    document.querySelector('#offerPriceContent_'+offer.offerProperty).style.display="";
    gwpMessageDisplayPost=true
     }
    }
    else{
    if(!gwpMessageDisplayPost){
    document.querySelector('#offerPriceContent_'+offer.offerProperty).innerHTML=offer.message_if_cart_value_is_greater_than_offer_value;
    document.querySelector('#offerPriceContent_'+offer.offerProperty).style.display="";
    gwpMessageDisplayPost=true
    }
    }
    
  }
   
});

await Promise.all(promises);
if(addFormDataArray.length >0){
  /*  const formDataAdd = {
    'items': addFormDataArray
  };
   await addProducts(formDataAdd);  
  document.dispatchEvent(new CustomEvent('cart:build'));
 */
  if(openCart) { document.querySelector(".js-drawer-open-cart").click();}
}  
else if(keyIds.length >0){
 /*   const commonValue = 0;
// Use reduce to create the object
   const formDataObject = keyIds.reduce((obj, keyId) => {
  obj[keyId] = commonValue;
  return obj;
   }, {});
  await updateProducts(formDataObject); 
  document.dispatchEvent(new CustomEvent('cart:build'));
  */
  if(openCart) { document.querySelector(".js-drawer-open-cart").click();}
}
else {
  addToCartBtn.classList.remove('btn--loading')
  document.querySelector('.card-load ').classList.remove('is-loading');
  }  
  
} 


async function processbuyXgetYOffers(cart, openCart) {
  addToCartBtn.classList.add('btn--loading');
  var cartData = cart;
  var scriptElement = document.querySelector("#CartBuyXAndGetYOffer");
  var gwpOffers = JSON.parse(scriptElement.textContent);

  const promises = gwpOffers.offers.map(async offer => {
    if (offer.enable_offers) {
      const productXQuantities = {};
      let productYInCart = cartData.items.find(item => item.id === offer.product_y);

      for (let j = 1; j <= 25; j++) {
        const productXId = offer[`choose_product_x_${j}`];
        const productXInCart = cartData.items.find(item => item.id === productXId);
        if (productXInCart) {
          productXQuantities[productXId] = productXInCart.quantity;
        }
      }

      const newXIds = Object.keys(productXQuantities);
      const existingYQuantity = productYInCart ? productYInCart.quantity : 0;

      if (existingYQuantity < newXIds.length) {
        // Add new Y products if necessary
        const formData = {
          'items': Array.from({ length: newXIds.length - existingYQuantity }, () => ({
            'id': offer.product_y,
            'quantity': 1,
            'properties': {
              '_Offer': offer.offerProperty
            }
          }))
        };
        await addProducts(formData);
      } else if (existingYQuantity > newXIds.length) {
        // Remove excess Y products if necessary
        const formData = {
          'id': productYInCart.key,
          'quantity': newXIds.length
        };
        await removeProducts(formData);
      }

      if (productYInCart && productYInCart.line_price > 0) {
        // Remove Y product if it's not part of the offer anymore
        const formData = {
          'id': productYInCart.key,
          'quantity': 0
        };
        await removeProducts(formData);
      }
    }
  });

  await Promise.all(promises);

  document.dispatchEvent(new CustomEvent('cart:build'));
  addToCartBtn.classList.remove('btn--loading');
  productBtn.classList.remove('btn--loading');
  document.querySelector('.card-load ').classList.remove('is-loading');
  if (openCart) {
    document.querySelector(".js-drawer-open-cart").click();
  }
}



async function addProducts(formData){
await fetch(window.Shopify.routes.root + 'cart/add.js', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json'
  },
  body: JSON.stringify(formData)
})
.then(async response => {
  return await response.json();
})
.catch((error) => {
  console.error('Error:', error);
});
}
async function removeProducts(formData){
await fetch(window.Shopify.routes.root + 'cart/change.js', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json'
  },
  body: JSON.stringify(formData)
})
.then( async response => {
  return await response.json();
})
.catch((error) => {
  console.error('Error:', error);
});
}

async function updateProducts(updates){
  await fetch(window.Shopify.routes.root + 'cart/update.js', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json'
  },
  body: JSON.stringify({ updates })
})
.then(response => {
  return response.json();
})
.catch((error) => {
  console.error('Error:', error);
});
}
// CART UPSELL ITEM FUNCTION
document.addEventListener('click', function(event) {
  if (event.target.classList.contains('upsell-button')) {
    var self = event.target;
    var ajaxcartProduct = self.closest('.ajaxcart__product');
    if (ajaxcartProduct) {
      var Id = ajaxcartProduct.id;
      var cartItemVariants = self.closest('.cart__item--variants');
      if (cartItemVariants) {
        var variant = cartItemVariants.querySelector('[name="variant"]').value;
        var xhr = new XMLHttpRequest();
        xhr.open('POST', '/cart/add.js', true);
        xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.onreadystatechange = function() {
          if (xhr.readyState === 4 && xhr.status === 200) {
            var data = JSON.parse(xhr.responseText);
            var selectors = {
              drawer: '#CartDrawer',
              container: '#CartContainer',
              template: '#CartTemplate',
              cartBubble: '.cart-link__bubble'
            };
            var form = document.querySelector(selectors.form);
            var drawer = new theme.Drawers('CartDrawer', 'cart');
            document.dispatchEvent(new CustomEvent('cart:build'));
            document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
              detail: {
                product: data
              }
            }));

          }
        };
        xhr.send(JSON.stringify({
          id: parseInt(variant),
          quantity: 1
        }));
      }
    }
  }
});

/*
    //CART UPSELL ITEM FUNCTION  
  $(document).on('click', '.upsell-button', function() { 
    var $self = $(this);
    var Id = $(this).closest('.ajaxcart__product').attr('id');   
    var Variant = $self.parents('.cart__item--variants').find('[name="variant"]').val();
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data : {
      id: parseInt(Variant),
      quantity: 1
      },
      dataType: 'json',
      success: function(data) {
      var selectors = {
      drawer: '#CartDrawer',
      container: '#CartContainer',
      template: '#CartTemplate',
      cartBubble: '.cart-link__bubble'
    }; 
      this.form = document.querySelector(selectors.form);
     // this.addToCart = form.querySelector(submitSelector);
      this.drawer = new theme.Drawers('CartDrawer', 'cart');
      document.dispatchEvent(new CustomEvent('cart:build'));
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: {
            product: data
            //addToCartBtn: this.addToCart
          }
        }));

        
      }
    })           
  });

*/
